import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VBtn,{attrs:{"small":"","rounded":"","color":"error"},on:{"click":_vm.reallyDelete}},[_vm._v("\n    Apagar \n    "),_c(VIcon,{attrs:{"right":""}},[_vm._v("mdi-delete")])],1),(_vm.loading)?_c('dialog-loading',{attrs:{"loadingText":"Apagando"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }